import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'
import { useCloseSidePanelPopOver } from '../../hooks'

export default function TabInlay(props) {
  const { items=[] } = props
  const { selected, organization, config } = useSelector(state=>state)
  const dispatch = useDispatch()
  const [filter, setFilter] = useState('')

  function updateSelected(payload){
    dispatch({type: "UPDATE_SELECTED", payload})
  }


  return (
    <div className="" style={{height: 'calc(100%)', overflowY: 'hidden' }}>
      <div className="p-xs-0 pl-lg-3 pr-lg-3 pt-lg-2">
        <input 
          className="form-control w-100 p-3 m-xs-0 mt-lg-3 mb-lg-3"
          placeholder="Type name..."
          value={filter}
          onChange={(e)=>setFilter(e.target.value)}/>
        {props.children}
      </div>
      { !config.isStaffApp && <hr className="m-xs-0 mt-lg-4 d-xs-none d-lg-block mb-lg-0"/> }
      <div className="h-100 pt-3 pb-5" style={{overflowY: "scroll" }}>
      {
        items.filter(item=> item.name.toLowerCase().includes(filter.toLowerCase())).map(item=>(
          <ItemListing 
            {...item} 
            isSelected={ selected.id == item.id && selected.resource_type == item.resource_type && selected.name == item.name }
            updateSelected={updateSelected} 
            organization={organization}
            key={item.id}/>
        ))
      }
      <div className="p-5 mt-5 mb-5"/>
      </div>
    </div>
  )
}


function ItemListing(props){
  const { name, id, resource_type, updateSelected, isSelected, organization } = props
  const handleCloseSidePanelPopOver = useCloseSidePanelPopOver()

  function handleClick(){
    document.dispatchEvent(new Event('closeAgendaFilter'))
    updateSelected({name, id, resource_type})
    handleCloseSidePanelPopOver()
  }

  return(
    <div 
      onClick={handleClick} 
      className={classnames("pl-3 pr-3 pt-2 pb-2 hoverable clickable cursor-pointer text-capitalize d-flex justify-content-between align-items-center", { "bg-primary": isSelected })}>
      {name}
      {
        resource_type != 'User' &&
        <a 
          target="_blank"
          href={generateUrl(organization, resource_type, id)}>
          <i className="fas fa-cog pl-1" style={{color: "rgb(176, 190, 197)"}}/>
        </a>
      }
    </div>
  )
}

function generateUrl(organization, resource_type, id){
  switch(resource_type){
    case "Calendar":
      return `/organizations/${organization.name}/calendars/${id}`
    case "User":
      return `/organizations/${organization.name}/users/${id}/schedules`
    case "Resident":
      return `/organizations/${organization.name}/residents/${id}/schedules`
  }
}